import { EMPLOYEE_FETCHED,IMPORT_EMPLOYEES} from "../types";


const initialState = {
  employeeData: [] as any,
  importEmployees:[] as any
};
const employee = (state = initialState, action: any) => {
  switch (action.type) {
    case EMPLOYEE_FETCHED:
      return {
        ...state,
        employeeData: action.employeeData,
        loading: false,
      };
    case IMPORT_EMPLOYEES:
      return {
        ...state,
        importEmployees: action.importEmployees,
        loading: false,
      };
    default:
      return state;
  }
};

export default employee;



